import { TouchPointHelper } from '../../../helpers/touchPointHelper';
import { placeholders, displayGroups } from '@ui';

export const requestContact = {
	prismName: 'requestContact',
	template: {
		templateName: 'requestContactTemplate',
		displayGroups: [
			TouchPointHelper.createDisplayGroup(
				displayGroups.pageContainer,
				[],
				[
					TouchPointHelper.createPlaceholder(placeholders.requestContact, {
						placeholderBuildReference: 10,
					}),
					TouchPointHelper.createPlaceholder(placeholders.modals, {
						placeholderBuildReference: 20,
					}),
				]
			),
		],
	},
};
